import Vue from 'vue'
import todoApi from '@/api/todo.api'
import fileApi from '@/api/file.api'
import { fileType } from '@/constants'


const state = {
  todos: {}
}


const getters = {
  todos: (state) => (projectId) => {
    let list = Object.values(state.todos) || []
    if (projectId) {
      list = list.filter(todo => todo.projectId === projectId)
    }
    return list
  },

  todoById: (state) => (id) => {
    return state.todos[id] || null
  }
}


const actions = {
  async loadTodos ({ commit, rootState }, { projectId, allProjects }) {
    const response = await todoApi.getTodos(rootState.tenant.current, projectId, allProjects)
    commit('SET_TODOS', { projectId, allProjects, todos: response.data })
  },

  async loadTodosByProject ({ commit, rootState }, projectId) {
    const allProjects = false
    const response = await todoApi.getTodos(rootState.tenant.current, projectId, allProjects)
    commit('SET_TODOS', { projectId, allProjects, todos: response.data })
  },

  // async loadTodoByTodoData ({ commit, rootState }, todoData) {
  //   const params = {
  //     toDoId: todoData.id,
  //     projectId: todoData.projectId
  //   }
  //   const response = await todoApi.getTodoByById(rootState.tenant.current, params)
  //   commit('UPDATE_TODO', response.data)
  //   return response
  // },
  //
  // async updateTodoByTodoData ({ commit, rootState }, todoData) {
  //   commit('UPDATE_TODO', todoData)
  // },

  async loadAndUpdateTodo ({ commit, rootState }, entityData) {
    const params = {
      toDoId: entityData.entityId,
      projectId: entityData.projectId
    }
    const response = await await todoApi.getTodoByById(rootState.tenant.current, params)
    commit('UPDATE_TODO', response.data)
    return response.data
  },


  async createAttachments ({ rootState }, attachments) {
    const projectId = rootState.project.currentId
    const result = []
    for (let i = 0; i < attachments.length; i++) {
      const attachment = attachments[i]
      const response = await fileApi.uploadFile(rootState.tenant.current, projectId, fileType.todoAttachment, attachment)
      result.push(response.data)
    }
    return result
  },

  async getAttachment ({ rootState }, attachmentId) {
    const projectId = rootState.project.currentId
    const response = await fileApi.downloadFile(rootState.tenant.current, projectId, attachmentId)
    return response
  },

  async createTodo ({ commit, rootState }, todo) {
    const response = await todoApi.createTodo(rootState.tenant.current, todo.projectId, todo)
    commit('CREATE_TODO', response.data)
    return response.data
  },

  async updateTodo ({ commit, rootState }, todo) {
    const response = await todoApi.updateTodo(rootState.tenant.current, todo.projectId, todo.id, todo)
    commit('UPDATE_TODO', response.data)
    return response.data
  },

  async deleteTodo ({ commit, rootState }, todo) {
    await todoApi.deleteTodo(rootState.tenant.current, todo.projectId, todo.id)
    commit('DELETE_TODO', todo.id)
  }
}


const mutations = {
  SET_TODOS (state, { projectId, allProjects, todos }) {
    if (allProjects) {
      state.todos = {}
    } else {
      for (const id in state.todos) {
        if (state.todos[id].projectId === projectId) {
          Vue.delete(state.todos, id)
        }
      }
    }

    for (const todo of todos) {
      Vue.set(state.todos, todo.id, todo)
    }
  },

  CREATE_TODO (state, todo) {
    Vue.set(state.todos, todo.id, todo)
  },

  UPDATE_TODO (state, todo) {
    Vue.set(state.todos, todo.id, todo)
  },

  DELETE_TODO (state, id) {
    Vue.delete(state.todos, id)
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
